
import PlaybackScreen from './PlaybackScreen.vue';
import LoginScreen from './auth/LoginScreen.vue';
import { ServerManager } from './common/servers';
import { NotificationService } from './common/notifications';
import NotificationToast from './common/NotificationToast.vue';
import { defineComponent } from 'vue';
import { QueueManager } from './queues/play-queue';
import SettingsDialog from './SettingsDialog.vue';
import { Settings, STORAGE_KEY_SETTINGS } from './common/settings';
import { LibraryManager } from './library';

export default defineComponent({
    components: {
        LoginScreen,
        PlaybackScreen,
        NotificationToast,
        SettingsDialog,
    },
    data() {
        const settingsString = window.localStorage.getItem(
            STORAGE_KEY_SETTINGS
        );
        const savedSettings: Partial<Settings> = settingsString
            ? JSON.parse(settingsString)
            : {};
        const settings = new Settings(savedSettings);
        const serverManager = new ServerManager();
        const libraryManager = new LibraryManager(serverManager);
        return {
            settings,
            /* eslint-disable -- eslint does not understand these values from DefinePlugin */
            appName: APP_NAME,
            appVersion: APP_VERSION,
            appSha: APP_SHA,
            /* eslint-enable */
            loggedIn: false,
            reconnectComplete: false,
            serverManager,
            libraryManager: libraryManager,
            queueManager: null as QueueManager | null,
            releaseVersionVisible: true,
            settingsOpen: false,
            username: '',
            serverName: '',
        };
    },
    provide() {
        return {
            libraryManager: this.libraryManager,
            settings: this.settings,
        };
    },
    computed: {
        appLoaded(): boolean {
            return (
                this.reconnectComplete &&
                ((this.loggedIn && this.libraryManager.allReady()) ||
                    !this.loggedIn)
            );
        },
    },
    created() {
        this.tryReconnect();
        this.$watch(
            'settings',
            (newSettings: Settings) => {
                newSettings.save();
            },
            { deep: true, immediate: true }
        );
    },
    methods: {
        logout() {
            const logoutPromises = this.serverManager
                .activeServers()
                .map((s) => this.serverManager.logout(s));
            Promise.all(logoutPromises).then(() => (this.loggedIn = false));
        },
        async tryReconnect(): Promise<void> {
            if (this.serverManager.knownServers().length > 0) {
                try {
                    await this.serverManager.reconnect();
                    await this.setupServers();
                } catch (err) {
                    console.log(err);
                    NotificationService.notifyError(err);
                    this.loggedIn = false;
                    this.reconnectComplete = true;
                }
            } else {
                this.reconnectComplete = true;
            }
        },
        async setupServers() {
            this.reconnectComplete = false;
            const activeServers = this.serverManager.activeServers();
            console.log('New servers: ', activeServers);
            if (activeServers.length > 0) {
                this.loggedIn = true;
                activeServers[0]
                    .username()
                    .then((username) => (this.username = username));
                activeServers[0]
                    .serverName()
                    .then((serverName) => (this.serverName = serverName));
                this.queueManager = await QueueManager.create(
                    this.libraryManager
                );
                this.reconnectComplete = true;
            } else {
                this.loggedIn = false;
                this.reconnectComplete = true;
            }
        },
    },
});
